import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="2wk09p15nonvi">
    <p className="font-display text-xl font-[800] italic leading-relaxed text-brand-green/85 md:text-3xl" data-id="element-1" data-mp="2wiffjcn976y6">
      🌸 Tu próxima consulta empieza con criterio, no con dudas.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-text selection:bg-brand-sageMist selection:text-brand-green" data-id="element-2" data-mp="23ti8k5ohswkq">
      <UrgencyBanner data-id="element-3" data-mp="3mkrdnl64zhdb" />
      <main data-id="element-4" data-mp="3mk85gw6ag7ch">
        <Hero data-id="element-5" data-mp="3mjq1fdddwou0" />
        <PackContents data-id="element-6" data-mp="3mjg8pi0yg3km" />
        <InitialTestimonials data-id="element-7" data-mp="3rcj6y3gog175" />
        <PainPoints data-id="element-8" data-mp="3rdas0kcnegj6" />
        <LaunchOffer data-id="element-9" data-mp="3rcsxbs5mwadd" />
        <MoreTestimonials data-id="element-10" data-mp="3reltgdimfc74" />
        <FAQ data-id="element-11" data-mp="6hqtghuuhen" />
        <CostComparison data-id="element-12" data-mp="6801qozk67w" />
        <TransitionPhrase data-id="element-13" data-mp="5gfdawxfswe" />
        <EmotionalClose data-id="element-14" data-mp="7suzhf7pr6a" />
      </main>
      <Footer data-id="element-15" data-mp="2zlv66six0xu0" />
      <FloatingNotification data-id="element-16" data-mp="2zm4v0cs84yy4" />
    </div>;
}